export enum PageRoutes {
    APPLICANT = '/applicant/:applicantId',
    APPLICANTS = '/applicants',
    AUTH_ERROR = '/auth-error',
    EMAIL_TEMPLATE_PREVIEW = '/debug/email-templates',
    HANGFIRE_DASHBOARD = '/hangfire',
    MANAGE_TEMPLATES = '/manage-templates',
    RECENT_NEEDS_MORE_INFO = '/recent-needs-more-info',
    HOME = '/',
    LOGIN_CALLBACK = '/login/callback',
}

export enum APIRoutes {
    APPLICANT = '/applicant/:applicantId',
    APPLICANT_ABANDON = '/applicant/:applicantId/abandon',
    APPLICANT_ACTIVITY = '/applicant/:applicantId/activity',
    APPLICANT_NOTIFICATION_HTML = '/applicant/:applicantId/notifications/:notificationId/html',
    APPLICANT_ALLOY_REFRESH_STATUS_LOADPAY = '/applicant/:applicantId/alloy/refresh-status-loadpay',
    APPLICANT_ALLOY_SYNC_DOCUMENTS = '/applicant/:applicantId/alloy/sync-documents',
    APPLICANT_ALLOY_MISSING_DOCUMENTS = '/applicant/:applicantId/alloy/missing-documents',
    APPLICANT_ASSIGNEE_DELETE = '/applicant/:applicantId/assignees/:assigneeId',
    APPLICANT_ASSIGNEES = '/applicant/:applicantId/assignees',
    APPLICANT_CONDITIONS = '/applicant/:applicantId/conditions',
    APPLICANT_CONDITION = '/applicant/:applicantId/conditions/:conditionId',
    APPLICANT_CONDITION_ATTACH_FILES = '/applicant/:applicantId/conditions/:conditionId/attach-files',
    APPLICANT_CONDITION_EDIT = '/applicant/:applicantId/conditions/:conditionId/edit',
    APPLICANT_CONDITION_NOTES = '/applicant/:applicantId/conditions/:conditionId/notes',
    APPLICANT_CONDITION_RESOLVE = '/applicant/:applicantId/conditions/:conditionId/resolve',
    APPLICANT_CONDITION_WATCHERS = '/applicant/:applicantId/conditions/:conditionId/watchers',
    APPLICANT_DOCS_CONFIRM_UPLOAD = '/applicant/:applicantId/confirm-upload',
    APPLICANT_DOCS_PRESIGN_URL = '/applicant/:applicantId/presign-url',
    APPLICANT_DOCUMENTS = '/applicant/:applicantId/documents',
    APPLICANT_DUE_DILIGENCE = '/applicant/:applicantId/due-diligence-data',
    APPLICANT_GENERATE_RECOVERY_LINK = '/applicant/:applicantId/generate-recovery-link',
    APPLICANT_NEEDS_MORE_INFO = '/applicant/:applicantId/needs-more-info',
    APPLICANT_NEEDS_MORE_INFO_PREVIEW = '/applicant/:applicantId/needs-more-info/preview',
    APPLICANT_REQUEST_INFO = '/applicant/:applicantId/request-info',
    APPLICANT_CANCEL_REQUEST_INFO = '/applicant/:applicantId/request-info/:informationRequestId',
    APPLICANT_NEXT_STEPS = '/applicant/:applicantId/next-steps',
    APPLICANT_POINT_OF_CONTACTS = '/applicant/:applicantId/point-of-contacts',
    SLACK_USER_DETAILS = '/slack/user-details',
    APPLICANT_NOTE = '/applicant/:applicantId/note',
    APPLICANT_REASON_CODES = '/applicant/:applicantId/reason-codes',
    APPLICANT_RELATED_ACCOUNTS = '/applicant/:applicantId/related-accounts',
    APPLICANT_WATCHLIST_MATCHES = '/applicant/:applicantId/watchlist-matches',
    APPLICANT_RESUBMIT = '/applicant/:applicantId/resubmit',
    APPLICANT_RETRY_ALLOY_FACTORING = '/applicant/:applicantId/retry-alloy-factoring',
    APPLICANT_RETRY_DDD = '/applicant/:applicantId/retry-ddd',
    APPLICANT_STATUS = '/applicant/:applicantId/status',
    APPLICANT_SUBMISSIONS = '/applicant/:applicantId/submissions',
    APPLICANT_SUBMISSION = '/applicant/:applicantId/submissions/:applicantSubmissionId',
    APPLICANT_TAGS = '/applicant/:applicantId/tags',
    APPLICANT_VENDOR_STATUS = '/applicant/:applicantId/vendor-status',
    APPLICANTS = '/applicants',
    APPLICANTS_ASSIGNEES = '/applicants/assignees',
    APPLICANTS_CONDITION_COUNTS = '/applicants/condition-counts',
    ASSIGNEES = '/assignees',
    CONDITION_DEFINITIONS = '/condition-definitions',
    CONDITION_DEFINITIONS_PLACEHOLDERS = '/condition-definitions/placeholders',
    CONDITION_DEFINITION_BY_ID = '/condition-definitions/:id',
    CONDITION_DEFINITIONS_PREVIEW = '/condition-definitions/preview',
    CONDITION_DEFINITIONS_TRIGGER_OPTIONS = '/condition-definitions/trigger-options',
    EMAIL_TEMPLATES = '/email-templates',
    EMAIL_TEMPLATES_PREVIEW = '/email-templates/preview',
    HANGFIRE_DASHBOARD_SESSION = '/hangfire-dashboard-session',
    NMI_TEMPLATES = '/nmi-templates',
    NMI_TEMPLATES_PLACEHOLDERS = '/nmi-templates/placeholders',
    NMI_TEMPLATE_BY_ID = '/nmi-templates/:id',
    NMI_TEMPLATES_PREVIEW = '/nmi-templates/preview',
    RECENT_NEEDS_MORE_INFO = '/needs-more-info',
    FILE_BY_ID = '/files/:fileId',
    FILE_UPDATE_FILENAME = '/files/:fileId/update-filename',
    FILE_UPDATE_DOCUMENT_TYPE = '/files/:fileId/update-document-type',
    PERMISSIONS_FEATURES = '/permissions/features',
}
